import React, { useRef, useState } from "react";
import { Button, Container, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import history from "../../../../utils/history";

const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: theme.spacing(4, 0),
    border: "1px solid #DBDCE1",
    padding: theme.spacing(3, 4)
  },
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightMedium
  },
  text: {
    fontSize: theme.typography.pxToRem(16),
    color: "#808080",
    margin: theme.spacing(2, 0, 3, 0)
  },
  navigateButton: {
    textTransform: "none",
    boxShadow: "none",
    fontWeight: "normal",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    "& svg": {
      color: "#fff",
      fontSize: "24px !important"
    },
    "&.Mui-disabled, &.Mui-disabled:hover": {
      backgroundColor: "#1329FE",
      color: "#fff",
      opacity: "38%"
    }
  }
}));

const SubscriptionNotice = props => {
  const { expired, failedToProcessTrial, failedToProcess } = props;

  // General
  const classes = useStyles();

  return (
    <Paper className={classes.wrapper} elevation={0}>
      <Typography className={classes.title}>
        {expired && !failedToProcess && !failedToProcessTrial
          ? "Your trial is over"
          : "Please update your payment method"}
      </Typography>
      <Typography className={classes.text}>
        {expired && !failedToProcess && !failedToProcessTrial
          ? "Please upgrade your account to continue routing."
          : failedToProcessTrial
          ? "We were unable to process your last payment. Please update your payment method in order to continue using Routetitan after your trial ends."
          : "We were unable to process your last payment. Please update your payment method in order to continue using Routetitan."}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className={classes.navigateButton}
        onClick={() =>
          history.push(
            expired ? "/payment/select-plan" : "/payment/edit-payment-method"
          )
        }
      >
        {expired ? "Select plan" : "Update payment"}
      </Button>
    </Paper>
  );
};

export default SubscriptionNotice;
